import { IGetResponse as SurveyClientResponse } from 'interfaceAdapter/gatewaySchemas/ICompanySurveyClient';
import { ISurvey, ISurveyQuestion, Survey, SurveyQuestionType } from 'domain/entities/Survey/Survey';

export interface ISurveyFactory {
    buildEmptySurvey(): ISurvey;
    buildSurvey(data: SurveyClientResponse['data'] | ISurvey): ISurvey;
}

export class SurveyFactory implements ISurveyFactory {
    public buildEmptySurvey(): ISurvey {
        return new Survey(0, '', '', [], []);
    }

    public buildSurvey(data: ISurvey): ISurvey {
        const question_data = data.question_data.map((question) => {
            return {
                id: question.id,
                question_type: question.question_type as SurveyQuestionType,
                title: question.title,
                description: question.description || '',
                required: question.required,
                answer_text_limit: question.answer_text_limit,
                selection: question.selection,
            } as ISurveyQuestion;
        });

        return new Survey(data.id, data.title, data.description || '', data.questions, question_data);
    }
}
